<script lang="ts" generics="ROW">
    import type {Readable} from 'svelte/store';
    import type {Table, RowModel} from '@tanstack/svelte-table';
    import KpGenericGridContainer from 'shared/ui-widgets/grid/KpGenericGridContainer.svelte';
    import {getGridContext} from 'shared/ui-widgets/grid/grid.context';
    import {isInEditMode} from 'shared/ui-widgets/grid/state/state-query';
    import KpContextMenuWrapper from 'shared/components/kp-context-menu/KpContextMenuWrapper.svelte';
    import KpGenericGridHeader from 'shared/ui-widgets/grid/KpGenericGridHeader.svelte';
    import KpGenericGridBody from 'shared/ui-widgets/grid/KpGenericGridBody.svelte';
    import KpGenericGridFooter from 'shared/ui-widgets/grid/KpGenericGridFooter.svelte';

    export let table$: Readable<Table<ROW>>;
    export let expandedFirstLevel = false;
    export let additionalClasses = '';
    export let additionalContainerClasses = '';

    const {stateManager: {state$}} = getGridContext();

    $: if (expandedFirstLevel) {
        expandFirstLevel($table$.getRowModel());
    }

    function expandFirstLevel(rowModel: RowModel<ROW>) {
        rowModel.rows
            .filter((row) => row.depth === 0)
            .filter((row) => !row.getIsExpanded())
            .forEach((row) => row.toggleExpanded(true));
    }
</script>

<KpGenericGridContainer {additionalContainerClasses} {additionalClasses}>
    <svelte:fragment slot="header">
        <KpGenericGridHeader {table$}/>
    </svelte:fragment>

    <svelte:fragment slot="body">
        {#if ($$slots['grid-context-menu'])}
            <KpContextMenuWrapper id="record-grid-context-menu" disabled="{isInEditMode($state$)}">
                <KpGenericGridBody {table$}/>
                <svelte:fragment slot="context-content" let:contextElementRef>
                    <slot name="grid-context-menu" {contextElementRef}/>
                </svelte:fragment>
            </KpContextMenuWrapper>
        {:else}
            <KpGenericGridBody {table$}/>
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="footer">
        <KpGenericGridFooter {table$}/>
    </svelte:fragment>
</KpGenericGridContainer>